/**
 * @file layers.js
 * @description Shared stacking layers (z-index) for windows that must sit above the app top bar.
 *   The top bar is 2000 (its menus 2400 to 2500). A page level modal below that was partly covered by
 *   the bar on phones (2026-10-17). Drawers and their overlays keep their own higher layers.
 * @module lib/layers
 */
export const LAYER_TOP_NAV = 2000;
/** Page level modals: above the top bar and its menus, below drawers (8800+) and payment windows. */
export const LAYER_PAGE_MODAL = 2600;
/** Stripe payment windows: above everything, including the Billing drawer (9000) and its overlays. */
export const LAYER_PAYMENT = 10000;
/**
 * Full screen document viewer (résumé PDF): above the floating profile and case cards (9000 to 9500 plus their
 * stacking offsets, TherapistProfileModal / FloatingMode) and drawers, below payment windows.
 */
export const LAYER_DOC_VIEWER = 9900;
